import { useEffect, useRef } from 'react'
import { useAtomValue } from 'jotai'
import { useNavigate, useLocation } from 'react-router'
import { session } from '../store'

export function useRequireOnboarding() {
  const currentSession = useAtomValue(session.sessionAtom)
  const navigate = useNavigate()
  const location = useLocation()
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (
      currentSession &&
      !currentSession.user.profile &&
      location.pathname !== '/onboarding' &&
      !hasRedirected.current
    ) {
      hasRedirected.current = true
      navigate('/onboarding', { replace: true })
    }
  }, [currentSession, navigate, location.pathname])
}
